import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navigation, heroContent } from '../data/mock';
import { Menu, X } from 'lucide-react';

const Navbar = ({ textColor = 'white', logoVariant = 'default', hoverColor = 'copper', showCenterLogo = true }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isEventPage = location.pathname === '/zeugmadan-sofraya-gaziantep';

  const getTextColorClass = () => {
    if (textColor === 'copper') return 'text-[#e4a483]';
    return textColor === 'green' ? 'text-[#1a441f]' : 'text-[#f8f8f8]';
  };

  const getHoverColorClass = () => {
    return hoverColor === 'white' ? 'hover:text-[#f8f8f8]' : 'hover:text-[#e4a483]';
  };

  const getLogoStyle = () => {
    if (logoVariant === 'green') {
      return { filter: 'brightness(0) saturate(100%) invert(19%) sepia(16%) saturate(2253%) hue-rotate(85deg) brightness(97%) contrast(92%)' };
    }
    if (logoVariant === 'white') {
      return { filter: 'brightness(0) invert(1)' };
    }
    return {};
  };

  return (
    <>
      <nav
        className="absolute top-0 left-0 right-0 z-50 py-6"
      >
        <div className="max-w-[1920px] mx-auto px-6 lg:px-8">
          <div className="relative flex items-center justify-between h-12">
            {/* Left Area: Home tagline, inner-page logo */}
            <div className="hidden lg:flex items-center w-1/3 justify-start">
              {isHomePage ? (
                <div className="text-[#e4a483] text-[1.1rem] tracking-[0.1em] font-medium whitespace-nowrap italic">
                  {heroContent.description}
                </div>
              ) : (
                <Link
                  to="/"
                  className="flex flex-col items-start group"
                >
                  <img
                    src="https://customer-assets.emergentagent.com/job_wealth-legacy-2/artifacts/vulhojge_gws.png"
                    alt="GWS Logo"
                    className="h-12 w-auto group-hover:scale-110 transition-transform duration-500"
                    style={getLogoStyle()}
                  />
                </Link>
              )}
            </div>

            {/* Center Logo - GWS Icon Only */}
            {showCenterLogo && isHomePage && (
              <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
                {isEventPage ? (
                  <div className="flex flex-col items-center group cursor-default">
                    <img
                      src="https://customer-assets.emergentagent.com/job_wealth-legacy-2/artifacts/vulhojge_gws.png"
                      alt="GWS Logo"
                      className="h-12 w-auto group-hover:scale-110 transition-transform duration-500"
                      style={getLogoStyle()}
                    />
                  </div>
                ) : (
                  <Link
                    to="/"
                    className="flex flex-col items-center group"
                  >
                    <img
                      src="https://customer-assets.emergentagent.com/job_wealth-legacy-2/artifacts/vulhojge_gws.png"
                      alt="GWS Logo"
                      className="h-12 w-auto group-hover:scale-110 transition-transform duration-500"
                      style={getLogoStyle()}
                    />
                  </Link>
                )}
              </div>
            )}

            {/* Right Navigation & Mobile Button */}
            <div className="flex items-center gap-8 w-full lg:w-1/3 justify-end">
              <div className="hidden lg:flex items-center gap-4">
                {navigation.right.map((item, index) => (
                  <React.Fragment key={item.name}>
                    <Link
                      to={item.href}
                      className={`${getTextColorClass()} text-[0.9rem] tracking-[0.1em] font-medium ${getHoverColorClass()} transition-colors duration-300`}
                    >
                      {item.name}
                    </Link>
                    {index < navigation.right.length - 1 && (
                      <span className={`${getTextColorClass()} text-[0.9rem] font-medium pb-[2px]`}>&middot;</span>
                    )}
                  </React.Fragment>
                ))}
              </div>

              {/* Mobile Menu Button */}
              <button
                className={`lg:hidden ${getTextColorClass()} p-2 ml-auto`}
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              >
                {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 bg-[#1a441f] transition-transform duration-500 lg:hidden ${
          isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex flex-col items-center justify-between h-full py-12">
          <div className="flex flex-col items-center justify-center flex-1 gap-8">
            {[...navigation.left, ...navigation.right].map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-[#f8f8f8] text-lg tracking-[0.3em] font-medium hover:text-[#e4a483] transition-colors duration-300"
                >
                  {item.name}
                </a>
              ))}
          </div>

          {/* Tagline at bottom */}
          <div className="text-[#e4a483] text-[1.1rem] italic px-6 text-center">
            Empowering the next generation of inheritors.
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
